// extracted by mini-css-extract-plugin
module.exports = {"center":"frontend-components-lessons-styles-Modal__center--2T_UI","description":"frontend-components-lessons-styles-Modal__description--1vmWg"};